import { useSelector } from "react-redux";

function getCompanySites(company) {
  const sitesList = [];
  company.subCompanies.forEach(({ sites }) => {
    sites.forEach((site) => sitesList.push(site.id));
  });
  return sitesList;
}

function useOrganisationTreeSelections(stateKey) {
  const { filterSelected } = useSelector((state) => state[stateKey]);
  const { site, subcompany, company } = filterSelected;
  const siteCallback = (x) => x.id;

  if (site.id) {
    return [site.id];
  }

  if (subcompany.id) {
    return subcompany.sites.map(siteCallback);
  }

  if (company.id) {
    return getCompanySites(company);
  }

  return null;
}

export default useOrganisationTreeSelections;
